/* eslint-disable */
import callDirections from '@ringcentral-integration/commons/enums/callDirections';
import callResults from '@ringcentral-integration/commons/enums/callResults';
import telephonyStatuses from '@ringcentral-integration/commons/enums/telephonyStatus';
export default {
  [callDirections.inbound]: 'Inbound',
  [callDirections.outbound]: 'Outbound',
  status: 'Status:',
  InboundNumber: 'Caller ID:',
  OutboundNumber: 'Called:',
  InboundDirection: 'Inbound from:',
  OutboundDirection: 'Outbound to:',
  [telephonyStatuses.noCall]: 'Disconnected',
  [telephonyStatuses.callConnected]: 'Connected',
  [telephonyStatuses.ringing]: 'Ringing',
  [telephonyStatuses.onHold]: 'On Hold',
  [telephonyStatuses.parkedCall]: 'Parked',
  [callResults.unknown]: 'Unknown',
  [callResults.missed]: 'Missed',
  [callResults.callAccepted]: 'Answered',
  [callResults.accepted]: 'Answered',
  [callResults.voicemail]: 'Voicemail',
  [callResults.rejected]: 'Declined',
  [callResults.reply]: 'Reply',
  [callResults.received]: 'Received',
  [callResults.faxReceiptError]: 'Fax receipt error',
  [callResults.faxOnDemand]: 'Fax on demand',
  [callResults.partialReceive]: 'Partially Received',
  [callResults.blocked]: 'Blocked',
  [callResults.callConnected]: 'Call connected',
  [callResults.noAnswer]: 'No Answer',
  [callResults.internationalDisabled]: 'International Disabled',
  [callResults.busy]: 'Busy',
  [callResults.faxSendError]: 'Fax send error',
  [callResults.sent]: 'Sent',
  [callResults.callFailed]: 'Call failed',
  [callResults.internalError]: 'Internal Error',
  [callResults.IPPhoneOffline]: 'IP Phone Offline',
  [callResults.restrictedNumber]: 'Restricted Number',
  [callResults.wrongNumber]: 'Wrong number',
  [callResults.stopped]: 'Stopped',
  [callResults.suspendedAccount]: 'Suspended account',
  [callResults.hangUp]: 'Hung up',
  [callResults.HangUp]: 'Hung up',
  [callResults.abandoned]: 'Abandoned',
  [callResults.declined]: 'Declined',
  [callResults.faxReceipt]: 'Fax receipt',
  [callResults.disconnected]: 'Disconnected',
  [callResults.notAllowed]: 'Not Allowed',
  warmTransferSwitchCall: 'Switch calls',
  conferenceCall: 'Conference Call',
  participants: 'Participants',
} as const;

// @key: @#@"[callDirections.inbound]"@#@ @source: @#@"Inbound"@#@
// @key: @#@"[callDirections.outbound]"@#@ @source: @#@"Outbound"@#@
// @key: @#@"status"@#@ @source: @#@"Status:"@#@
// @key: @#@"InboundNumber"@#@ @source: @#@"Caller Id:"@#@
// @key: @#@"OutboundNumber"@#@ @source: @#@"Called:"@#@
// @key: @#@"InboundDirection"@#@ @source: @#@"Inbound from:"@#@
// @key: @#@"OutboundDirection"@#@ @source: @#@"Outbound to:"@#@
// @key: @#@"[telephonyStatuses.noCall]"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"[telephonyStatuses.callConnected]"@#@ @source: @#@"Connected"@#@
// @key: @#@"[telephonyStatuses.ringing]"@#@ @source: @#@"Ringing"@#@
// @key: @#@"[telephonyStatuses.onHold]"@#@ @source: @#@"On Hold"@#@
// @key: @#@"[telephonyStatuses.parkedCall]"@#@ @source: @#@"Parked"@#@
// @key: @#@"[callResults.unknown]"@#@ @source: @#@"Unknown"@#@
// @key: @#@"[callResults.missed]"@#@ @source: @#@"Missed"@#@
// @key: @#@"[callResults.callAccepted]"@#@ @source: @#@"Answered"@#@
// @key: @#@"[callResults.accepted]"@#@ @source: @#@"Answered"@#@
// @key: @#@"[callResults.voicemail]"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"[callResults.rejected]"@#@ @source: @#@"Declined"@#@
// @key: @#@"[callResults.reply]"@#@ @source: @#@"Reply"@#@
// @key: @#@"[callResults.received]"@#@ @source: @#@"Received"@#@
// @key: @#@"[callResults.faxReceiptError]"@#@ @source: @#@"Fax Receipt Error"@#@
// @key: @#@"[callResults.faxOnDemand]"@#@ @source: @#@"Fax on Demand"@#@
// @key: @#@"[callResults.partialReceive]"@#@ @source: @#@"Partial Receive"@#@
// @key: @#@"[callResults.blocked]"@#@ @source: @#@"Blocked"@#@
// @key: @#@"[callResults.callConnected]"@#@ @source: @#@"Call connected"@#@
// @key: @#@"[callResults.noAnswer]"@#@ @source: @#@"No Answer"@#@
// @key: @#@"[callResults.internationalDisabled]"@#@ @source: @#@"International Disabled"@#@
// @key: @#@"[callResults.busy]"@#@ @source: @#@"Busy"@#@
// @key: @#@"[callResults.faxSendError]"@#@ @source: @#@"Fax Send Error"@#@
// @key: @#@"[callResults.sent]"@#@ @source: @#@"Sent"@#@
// @key: @#@"[callResults.callFailed]"@#@ @source: @#@"Call Failed"@#@
// @key: @#@"[callResults.internalError]"@#@ @source: @#@"Internal Error"@#@
// @key: @#@"[callResults.IPPhoneOffline]"@#@ @source: @#@"IP Phone Offline"@#@
// @key: @#@"[callResults.restrictedNumber]"@#@ @source: @#@"Restricted Number"@#@
// @key: @#@"[callResults.wrongNumber]"@#@ @source: @#@"Wrong Number"@#@
// @key: @#@"[callResults.stopped]"@#@ @source: @#@"Stopped"@#@
// @key: @#@"[callResults.suspendedAccount]"@#@ @source: @#@"Suspended Account"@#@
// @key: @#@"[callResults.hangUp]"@#@ @source: @#@"Hung up"@#@
// @key: @#@"[callResults.HangUp]"@#@ @source: @#@"Hung up"@#@
// @key: @#@"[callResults.abandoned]"@#@ @source: @#@"Abandoned"@#@
// @key: @#@"[callResults.declined]"@#@ @source: @#@"Declined"@#@
// @key: @#@"[callResults.faxReceipt]"@#@ @source: @#@"Fax Receipt"@#@
// @key: @#@"[callResults.disconnected]"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"[callResults.notAllowed]"@#@ @source: @#@"Not Allowed"@#@
// @key: @#@"warmTransferSwitchCall"@#@ @source: @#@"Switch calls"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
